import { ChartActionsComponentProps, ChartMetaFormField } from 'models/ui';
import { Box, ChartActions, ErrorFormField } from 'components/common';
import { ELSButton } from 'components/common/els';
import { FormField } from './ProgressNotes';

export interface ProgressNotesFormViewProps {
  chartMetaFormFields: Map<string, ChartMetaFormField>;
  formSubmittedCount: number;
  isDisabledSave?: boolean;
  onSave?: Function;
  chartActionsProps?: ChartActionsComponentProps;
  isSidebarView: boolean;
}

export const defaultProps = {
  isSidebarView: false
};

const ProgressNotesFormView = (props: ProgressNotesFormViewProps) => (
  <>
    <div className="u-els-width-2o3">
      <ErrorFormField formField={props.chartMetaFormFields.get(FormField.PROGRESS_NOTES)} formSubmittedCount={props.formSubmittedCount} />
    </div>
    <div className="u-els-width-1o3">
      <ErrorFormField formField={props.chartMetaFormFields.get(FormField.SIGNATURE)} formSubmittedCount={props.formSubmittedCount} />
    </div>
    {props.isSidebarView ? (
      <Box mb className="sng-form-buttons">
        <ELSButton attrType="submit" text="Save" isDisabled={props.isDisabledSave} onClick={props.onSave} />
      </Box>
    ) : (
      <ChartActions {...props.chartActionsProps} />
    )}
  </>
);

ProgressNotesFormView.displayName = 'ProgressNotesFormView';
ProgressNotesFormView.defaultProps = defaultProps;

export default ProgressNotesFormView;
